import React, { useRef, useEffect, useState } from 'react';
import { useScrollBehavior } from './useScrollBehavior.js';
import SlideInDiv2 from './slider1.js';
import SlideInDivLeft2 from './slider2.js';
import './module_three_hook.css';

const ModuleThreeHook = () => {
  useScrollBehavior();

  const centerRef2 = useRef(null);
  const [isVisibleCenter2, setIsVisibleCenter2] = useState(false);

  const handleScroll2 = () => {
    if (centerRef2.current) {
      const centerRect2 = centerRef2.current.getBoundingClientRect();
      const triggerOffsetCenter2 = 100;
      const triggerPointCenter2 = window.innerHeight - triggerOffsetCenter2;
      const isAboveTriggerPointCenter2 = centerRect2.top < triggerPointCenter2;
      setIsVisibleCenter2(isAboveTriggerPointCenter2);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll2);
    handleScroll2();

    return () => {
      window.removeEventListener('scroll', handleScroll2);
    };
  }, []);

  return (
    <div className="module" id="moduleThree">
      <div id='mod3_div' ref={centerRef2}>
        <div className='mod3_sub_div'>
          <div
            id='mod3_internal_div1'
            ref={centerRef2}
            className={`mod3_internal_div ${isVisibleCenter2 ? 'visible' : ''}`}
            style={{ transitionDelay: '.5s' }}
          >
            <div id='mod3_internal_div1_sub'>
              <h1>Web Design & Development</h1>
              <br />
              <p>
                Our expertise lies in creating beautiful, SEO-driven
                web solutions that engage users, accelerate your
                business&apos;s expansion, and profoundly extend your
                partners&apos; reach and purpose.
              </p>
            </div>
          </div>

          <div
            id='mod3_internal_div2'
            ref={centerRef2}
            className={`mod3_internal_div ${isVisibleCenter2 ? 'visible' : ''}`}
            style={{ transitionDelay: '1.6s' }}
          >
            <SlideInDiv2>
              <div id='white_space2'>
                <h1>Brand Identity</h1>
                <br />
                <p>
                  We develop cohesive brand systems that ensure clarity, consistency,
                  and alignment across every digital touchpoint. The objective is not
                  reinvention, but the creation of a structured identity that reinforces
                  credibility and strengthens recognition as your organization grows.
                </p>
              </div>
            </SlideInDiv2>
          </div>
        </div>

        <div className='mod3_sub_div'>
          <div
            id='mod3_internal_div3'
            ref={centerRef2}
            className={`mod3_internal_div ${isVisibleCenter2 ? 'visible' : ''}`}
            style={{ transitionDelay: '1.2s' }}
          >
            <SlideInDivLeft2>
              <div id='white_space'>
                <h1>Digital Marketing</h1>
                <br />
                <p>
                  Our digital marketing and SEO initiatives are built
                  to integrate seamlessly with your website ecosystem.
                  Strategy, implementation, and ongoing optimization work
                  together to generate qualified demand and deliver
                  measurable, sustainable growth.
                </p>
              </div>
            </SlideInDivLeft2>
          </div>

          <div
            id='mod3_internal_div4'
            ref={centerRef2}
            className={`mod3_internal_div ${isVisibleCenter2 ? 'visible' : ''}`}
            style={{ transitionDelay: '1.5s' }}
          ></div>
        </div>
      </div>
    </div>
  );
};

export default ModuleThreeHook;